/*
 * @Author: shuchang
 * @Date: 2021-06-03 17:12:21
 * @LastEditors: shuchang
 * @LastEditTime: 2022-09-14 15:30:34
 * @Description:
 */

import {
  fetchGet,
  fetchPost,
  fetchPostUrl,
  fetchPostImg,
  fetchGetSso,
} from "@/fetch/fetch";

export function getLogined(params) {
  return fetchGet(`passport-operate-api/getLogined`, params);
}
export function captcha(params, config) {
  return fetchPostImg(`passport-operate-api/captcha`, params, config);
}
export function logout(params) {
  return fetchPost(`passport-operate-api/userLogout`, params);
}
// 登录
export function login(params) {
  return fetchPostUrl(`passport-operate-api/userLogin`, params);
}
// 获取首页子系统
export function listSystem(params) {
  return fetchGet(`passport-operate-api/index/listSystem`, params);
}

export function checkLogined(params) {
  return fetchGetSso(`checkLogined`, params);
}
// 获取图片地址
export function getFile(id, params) {
  return fetchGet(`filereso-api/oss/file/getFile?fileId=${id}`, params);
}
// 修改用户头像
export function changeAvatar(params) {
  return fetchPostUrl(`passport-operate-api/changeAvatar`, params);
}
// 修改密码
export function changePwdByMsg(params) {
  return fetchPostUrl(`passport-operate-api/changePwdByMsg`, params);
}
// 获取小马员工登录模块及系统
export function listModSysByStaffId(params) {
  return fetchPost(`passport-operate-api/index/listModSysByStaffId`, params);
}
// 运营客户端菜单
export function listOperatMenu(params) {
  return fetchGet(`passport-operate-api/index/listOperatMenu`, params);
}
// 获取webSocket地址
export function getKeysByCode(params) {
  return fetchGet(`/basicdata-api/sysconfig/getKeysByCode`, params);
}
// 获取二维码
export function getLoginQr(params) {
  return fetchGet(`passport-operate-api/getLoginQr`, params);
}
// 获取验证码
export function fetchSmsCheckCode(params) {
  return fetchPostUrl(`passport-operate-api/fetchSmsCheckCode`, params);
}
// 验证码登录
export function userLoginByCode(params) {
  return fetchGet(`passport-operate-api/userLoginByCode`, params);
}
// 获取手机验证码
export function getSmsCode(params) {
  return fetchGet(`passport-operate-api/getSmsCode`, params);
}
